module.exports = __webpack_public_path__ + "1073b94b4ad143ab6e6dd00bf6b6d0a1.svg";